export default "__VITE_ASSET__DzyWTgeN__"